export const shortenBalance = (balance: string, shortenTo: number = 5) =>
  `${balance.split('.').shift()}${
    balance.includes('.')
      ? `.${balance.split('.').pop()!.slice(0, shortenTo)}`
      : ''
  }`;
